var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('themed-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("\n        Feature flags\n    ")]),_c('v-card-text',{staticClass:"text--primary"},[_c('available-feature-flags'),_c('current-user-flags'),_c('current-user-groups')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }